import moment from "moment";
import React from "react";
import { states } from "../layouts/Wizard/States/States";
import OggettiUtili from "./OggettiUtili.json";
import Input from "../components/textbox/Input";
import RadioButton from "../components/radiobutton/RadioButton";
import Calendar from "../components/calendar/Calendar";
import styles from "../layouts/Wizard/WizardSteps/DatiSpecifici/DatiSpecifici.module.css";
import Select from "../components/select/Select";
import Autocomplete from "../components/autocomplete/Autocomplete";
import CheckBox from "../components/checkbox/CheckBox";
import Permessi from "../utils/Permessi";
import $ from "jquery";
import SessioneUtente from "../sessionManager/SessioneUtente";
import atob from "atob";
import SegnalazioniService from "../services/SegnalazioniServices";
import Ruoli from "./Ruoli.json";

export default class Utils {
    static SorterObjectDesc(a, b) {
        if (a.descrizione && b.descrizione) {
            var vA = a.descrizione;
            var vB = b.descrizione;
        } else {
            var vA = a.label;
            var vB = b.label;
        }
        if (vA < vB) return -1;
        if (vA > vB) return 1;
        return 0;
    }

    static mapToGraph(intervallo, rapporto, el, m) {
        let params = {};
        let rapportoReport = true;
        params.malattia = el.malattia
            ? m[el.malattia]
                ? m[el.malattia].descrizione
                : el.malattia
            : "";

        if (el.rangeGenerico && !el.range) {
            params.femmineTot = el.rangeGenerico.femmine;
            params.maschiTot = el.rangeGenerico.maschi;
        } else {
            if (rapporto) {
                for (
                    let i = 0;
                    i <
                    OggettiUtili.ReportStatisticiIntervallo[intervallo].length;
                    i++
                ) {
                    if (rapportoReport) {
                        for (
                            let j = 0;
                            j <
                            OggettiUtili.ReportStatisticiIntervallo[intervallo]
                                .length;
                            j++
                        ) {
                            params[
                                OggettiUtili.ReportStatisticiIntervallo[
                                    intervallo
                                ][j].codice
                            ] =
                                el.range[
                                    OggettiUtili.ReportStatisticiIntervallo[
                                        intervallo
                                    ][j].descrizione
                                ][
                                    OggettiUtili.ReportStatisticiIntervallo[
                                        intervallo
                                    ][j].sesso
                                ];
                            if (
                                OggettiUtili.ReportStatisticiIntervallo[
                                    intervallo
                                ][j].rapporto
                            ) {
                                rapportoReport = false;
                                i = j;
                                break;
                            }
                        }
                    }
                    params[
                        OggettiUtili.ReportStatisticiIntervallo[intervallo][
                            i
                        ].codice
                    ] =
                        el.range[
                            OggettiUtili.ReportStatisticiIntervallo[intervallo][
                                i
                            ].descrizione
                        ][
                            OggettiUtili.ReportStatisticiIntervallo[intervallo][
                                i
                            ].sesso
                        ];
                }
            } else {
                for (
                    let i = 0;
                    i < OggettiUtili.ReportStatistici[intervallo].length;
                    i++
                ) {
                    params[
                        OggettiUtili.ReportStatistici[intervallo][i].codice
                    ] =
                        el.range[
                            OggettiUtili.ReportStatistici[intervallo][
                                i
                            ].descrizione
                        ].totale;
                }
            }
        }

        params.totale = el.rangeGenerico.totale;
        params.femmineTot = el.rangeGenerico.femmine;
        params.maschiTot = el.rangeGenerico.maschi;
        params.mediaRegionale = el.mediaRegionale;
        params.grafico = "Visualizza grafico";
        return params;
    }

    static MAGIC = 86400000;

    static DateToDays(date) {
        //  convert a date to an integer and back agai
        const moonLanding = new Date(date);
        let currentTime = moonLanding.getTime();
        currentTime = currentTime / this.MAGIC;
        return Math.floor(currentTime) + 1;
    }

    static DaysToDate(days) {
        //  convert integer back again to a date
        let currentTime = days * this.MAGIC;
        //var x = new Date(currentTime);
        return this.trasformData(currentTime);
    }

    static trasformData(date) {
        var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [day, month, year].join("-");
    }

    static idSegnalazioneRegex = "^[0-9]{15}$";

    static mapMalattie(codice) {
        let m = JSON.parse(sessionStorage.getItem("malattiePerCodice"));
        for (let key in m) {
            if (codice === key) {
                console.log(m[key].descrizione);
                return m[key].descrizione;
            }
        }
    }

    static mapMalattieDescrizione(descrizione) {
        let m = JSON.parse(sessionStorage.getItem("malattiePerDescrizione"));
        for (let key in m) {
            if (descrizione === key) {
                console.log(m[key].codice);
                return m[key].codice;
            }
        }
    }

    static getSingleMedico(el) {
        let element = {
            idMedico: "",
            cognomeNome: "",
            cognome: "",
            nome: "",
            ruolo: "",
            ulss: "",
            recapitoTelefonico: "",
            fax: "",
            email: "",
            medicoAnagrafe: "",
        };
        element.idMedico = el.idMedico??"";
        element.cognomeNome = el.cognome + " " + el.nome;
        element.cognome = el.cognome??"";
        element.nome = el.nome??"";
        element.ulss = el.ulss??"";
        element.ruolo = el.ruolo??"";
        element.recapitoTelefonico = el.recapitoTelefonico??"";
        element.fax = el.fax??"";
        element.email = el.email??"";
        element.medicoAnagrafe = el.medicoAnagrafe??"";
        return element;
    }

    static mapGetMedico(data) {
        let res = [];
        data.data.forEach(function (el) {
            res.push(Utils.getSingleMedico(el));
        });
        return res;
    }

    static mapGetMedicoPerForm(row) {
        let element = {
            idMedico: "",
            nome: "",
            cognome: "",
            ruolo: "",
            ulss: "",
            recapitoTelefonico: "",
            fax: "",
            email: "",
            medicoAnagrafe: "",
        };
        element.idMedico = row.idMedico;
        element.nome = row.cognomeNome.split(" ")[1];
        element.cognome = row.cognomeNome.split(" ")[0];
        element.ruolo = row.ruolo;
        element.ulss = row.ulss;
        element.recapitoTelefonico = row.recapitoTelefonico;
        element.fax = row.fax;
        element.email = row.email;
        element.medicoAnagrafe = row.medicoAnagrafe;
        return element;
    }

    static mapGetPazientePerForm(row) {
        let nazioniPerCodice = JSON.parse(
            sessionStorage.getItem("nazioniPerCodice")
        );
        let element = {
            idAnagrafica: "",
            nomePaziente: "",
            cognomePaziente: "",
            dataDiNascita: "",
            codiceFiscale: "",
            stp: "",
            sesso: "",
            eta: "",
            mesi: "",
            comuneNascita: "",
            statoEstero: "",
            cfNonNoto: false,
            nonInRegola: false,
            senzaFissaDimore: false,
            regioneResidenza: "",
            provinciaResidenza: "",
            comuneResidenza: "",
            indirizzoResidenza: "",
            aslAppartenenza: "",
            comuneDomicilio: "",
            indirizzoDomicilio: "",
            aslDomicilio: "",
            cittadinanza: "",
            recapitoTelefonicoPaziente: "",
            ssn: "",
            professione: "",
        };
        element.idAnagrafica = row.idAnagrafica;
        element.cognomePaziente = row.cognome;
        element.nomePaziente = row.nome;
        element.codiceFiscale = row.codiceFiscale;
        element.dataDiNascita = row.dataNascita;
        element.eta = row.eta;
        element.mesi = row.etaMesi;
        element.recapitoTelefonicoPaziente = row.recapitoTelefonicoPaziente;
        element.sesso = row.sesso;
        element.stp = row.stp;
        element.cittadinanza = nazioniPerCodice[row.cittadinanza]
            ? nazioniPerCodice[row.cittadinanza]
            : "";
        element.professione = row.professione
            ? row.professione
            : OggettiUtili.Professioni["0"].codice;
        element.ssn = row.ssn;
        element.comuneNascita = row.comuneNascita;
        element.regioneResidenza = row.regioneResidenza;
        element.comuneResidenza = row.comuneResidenza;
        element.provinciaResidenza = row.provinciaResidenza;
        element.indirizzoResidenza = row.indirizzoResidenza;
        element.aslAppartenenza =
            row.aslAppartenenza && row.aslAppartenenza.codice
                ? row.aslAppartenenza.codice
                : "";
        element.comuneDomicilio = row.comuneDomicilio;
        element.indirizzoDomicilio = row.indirizzoDomicilio;
        element.aslDomicilio =
            row.aslDomicilio && row.aslDomicilio.codice
                ? row.aslDomicilio.codice
                : "";
        element.cfNonNoto = row.cfNonNoto;
        console.log(element);
        return element;
    }

    static mapGetPaziente(data, dataCompilazione) {
        let res = [];
        let comuniPerCodice = JSON.parse(
            sessionStorage.getItem("comuniPerCodice")
        );
        let allComuniPerCodice = Utils.arrayToMap(
            JSON.parse(localStorage.getItem("comuni")),
            "codice"
        );
        let regioniPerCodice = OggettiUtili.Regioni;
        let provincePerCodice = JSON.parse(
            sessionStorage.getItem("provincePerCodice")
        );
        let nazioniPerCodice = JSON.parse(
            sessionStorage.getItem("nazioniPerCodice")
        );
        let comuniAulssPerCodice = JSON.parse(
            sessionStorage.getItem("comuniPerCodice")
        );
        let aulss = Utils.arrayToMap(
            JSON.parse(localStorage.getItem("aulss")),
            "codiceAziendaEsteso"
        );
        let ulssResidenza = {};
        let ulssDomicilio = {};
        let ulssByCodiceComuneResidenza = "";
        let ulssByCodiceComuneDomicilio = "";

        let nazionalitaPerCodice = OggettiUtili.NazionalitaPerCodice;
        let arrayUlss = [];
        Object.keys(OggettiUtili.ulssMap).map((key) => {
            arrayUlss.push(OggettiUtili.ulssMap[key]);
        });

        data.data.anagraficaRicercaDTOList.forEach(function (el) {
            let element = {
                idAnagrafica: "",
                cognomeNome: "",
                codiceFiscale: "",
                dataNascita: "",
                sesso: "",
                comuneNascita: "",
                stp: "",
                cittadinanza: "",
                professione: "",
                recapitoTelefonicoPaziente: "",
                ssn: "",
                aslAppartenenza: "",
                nome: "",
                cognome: "",
                regioneResidenza: "",
                provinciaResidenza: "",
                comuneResidenza: "",
                indirizzoResidenza: "",
                comuneDomicilio: "",
                indirizzoDomicilio: "",
                aslDomicilio: "",
                statoEstero: "",
                nonInRegola: "",
                senzaFissaDimora: "",
                recapitoTelefonico: "",
                cfNonNoto: "",
                etaMesi: 0,
            };
            let dataCompilazioneSegnalazione = Date.parse(
                Utils.transformDateForBackend(dataCompilazione)
            );
            let dataNascita = Date.parse(el.dataNascita);
            let dataComp = moment(dataCompilazioneSegnalazione);
            let dataNasc = moment(dataNascita);
            let anni = dataComp.diff(dataNasc, "years");
            let mesi = dataComp.diff(dataNasc, "months") % 12;

            let residenza = {};
            let domicilio = {};
            for (let i = 0; i < el.indirizzi.length; i++) {
                if (el.indirizzi[i].tipoIndirizzo === 1) {
                    residenza = el.indirizzi[i];
                } else if (el.indirizzi[i].tipoIndirizzo === 2) {
                    domicilio = el.indirizzi[i];
                }
            }

            element.idAnagrafica = el.id;
            element.cognomeNome = el.cognome + " " + el.nome;
            element.nome = el.nome;
            element.cognome = el.cognome;
            element.codiceFiscale = el.codiceFiscale;
            element.dataNascita = Utils.formatDateISO(el.dataNascita, "/");
            element.eta = anni;
            element.etaMesi = mesi;
            element.sesso = el.sesso;
            element.stp = el.stp;
            element.cittadinanza = nazionalitaPerCodice[el.cittadinanza]
                ? nazionalitaPerCodice[el.cittadinanza].descrizione
                : "";
            element.comuneNascita = allComuniPerCodice[el.comuneNascita]
                ? allComuniPerCodice[el.comuneNascita]
                : nazioniPerCodice[el.comuneNascita]
                ? nazioniPerCodice[el.comuneNascita]
                : "";
            if (element.regioneResidenza && element.regioneResidenza.length===2){
                element.regioneResidenza=element.regioneResidenza.concat("0")
            }
            element.regioneResidenza = regioniPerCodice[residenza.regione]
                ? regioniPerCodice[residenza.regione]
                : regioniPerCodice["0"];
            element.comuneResidenza = comuniPerCodice[residenza.comune];
            element.provinciaResidenza =
                provincePerCodice[element.comuneResidenza.codiceProvincia];
            element.indirizzoResidenza = residenza.indirizzo;
            if (residenza.ulss && residenza.ulss !== "") {
                ulssResidenza.codice = residenza.ulss;
                ulssResidenza.descrizione = aulss[residenza.ulss].descrizione;
            } else if (residenza.comune && residenza.comune !== "") {
                ulssByCodiceComuneResidenza =
                    comuniAulssPerCodice[residenza.comune].codiceAulss;
                ulssResidenza.codice = ulssByCodiceComuneResidenza;
                ulssResidenza.descrizione =
                    aulss[ulssByCodiceComuneResidenza].descrizione;
            }
            element.aslAppartenenza = aulss[ulssResidenza.codice];

            element.comuneDomicilio = comuniPerCodice[domicilio.comune];
            element.indirizzoDomicilio = domicilio.indirizzo;
            if (domicilio.ulss && domicilio.ulss !== "") {
                ulssDomicilio.codice = domicilio.ulss;
                ulssDomicilio.descrizione = aulss[domicilio.ulss].descrizione;
            } else if (domicilio.comune && domicilio.comune !== "") {
                ulssByCodiceComuneDomicilio =
                    comuniAulssPerCodice[domicilio.comune].codiceAulss;
                ulssDomicilio.codice = ulssByCodiceComuneDomicilio;
                ulssDomicilio.descrizione =
                    aulss[ulssByCodiceComuneDomicilio].descrizione;
            }
            element.aslDomicilio = aulss[ulssDomicilio.codice];
            element.statoEstero = el.statoEstero;
            element.nonInRegola = el.nonInRegola;
            element.senzaFissaDimora = el.senzaFissaDimora;
            element.ssn = el.codiceSsn;
            element.recapitoTelefonico = el.contatti
                ? el.contatti[0].valore
                : "";
            // element.cfNonNoto = el.cfNonNoto?el.cfNonNoto:el.codiceFiscale?"":true
            console.log(element);
            res.push(element);
        });
        return res;
    }

    static unique(el) {
        let arr = [];

        for (let i = 0; i < el.length; i++) {
            for (let j = i + 1; j < el.length + 1; j++) {
                if ((el[i] != el[j] && j < el.length) || i == el.length - 1) {
                    arr[i] = el[i];
                }
                if (el[i] == el[j]) {
                    arr[i] = "";
                    break;
                }
            }
        }

        let newArr = [];
        let j = 0;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i]) {
                newArr[j] = arr[i];
                j = j + 1;
            }
        }

        return newArr;
    }

    static mapGetPazientePerModifica(el, dataCompilazione) {
        let allComuniPerCodice = Utils.arrayToMap(
            JSON.parse(localStorage.getItem("comuni")),
            "codice"
        );
        let comuniPerCodice = JSON.parse(
            sessionStorage.getItem("comuniPerCodice")
        );
        let regioniPerCodice = OggettiUtili.Regioni;
        let provincePerCodice = JSON.parse(
            sessionStorage.getItem("provincePerCodice")
        );
        let nazioniPerCodice = JSON.parse(
            sessionStorage.getItem("nazioniPerCodice")
        );
        let comuniNazioni = Object.assign(
            {},
            comuniPerCodice,
            nazioniPerCodice
        );

        let arrayUlss = [];
        Object.keys(OggettiUtili.ulssMap).map((key) => {
            arrayUlss.push(OggettiUtili.ulssMap[key]);
        });

        let element = {
            idAnagrafica: "",
            cognomeNome: "",
            soggettoAnonimizzato: "",
            codiceFiscale: "",
            dataNascita: "",
            sesso: "",
            comuneNascita: "",
            stp: "",
            cittadinanza: "",
            professione: "",
            recapitoTelefonicoPaziente: "",
            ssn: "",
            aslAppartenenza: "",
            nome: "",
            cognome: "",
            regioneResidenza: "",
            provinciaResidenza: "",
            comuneResidenza: "",
            indirizzoResidenza: "",
            comuneDomicilio: "",
            indirizzoDomicilio: "",
            aslDomicilio: "",
            statoEstero: "",
            nonInRegola: "",
            senzaFissaDimora: "",
            recapitoTelefonico: "",
            cfNonNoto: "",
            mesi: 0,
        };
        let dataCompilazioneSegnalazione = Date.parse(
            Utils.transformDateForBackend(dataCompilazione)
        );
        let yearDataCompilazioneSegnalazione = new Date(
            dataCompilazioneSegnalazione
        ).getUTCFullYear();

        let residenza = {};
        let domicilio = {};
        for (let i = 0; i < el.indirizzo.length; i++) {
            if (el.indirizzo[i].tipoIndirizzo === 1) {
                residenza = el.indirizzo[i];
            } else if (el.indirizzo[i].tipoIndirizzo === 2) {
                domicilio = el.indirizzo[i];
            }
        }
        // element.soggettoAnonimizzato = el.soggettoAnonimizzato,
        element.idAnagrafica = el.id;
        element.nomePaziente = el.nome;
        element.cognomePaziente = el.cognome;

        if (el.codiceFiscale && el.codiceFiscale.toUpperCase() === "NON_NOTO")
            element.cfNonNoto = true;
        else element.codiceFiscale = el.codiceFiscale;

        element.dataDiNascita = el.dataNascita
            ? Utils.formatDateISO(el.dataNascita, "/")
            : "";

        if (el.dataNascita) {
            let dataComp = moment(dataCompilazione);
            let dataNasc = moment(el.dataNascita);
            element.eta = dataComp.diff(dataNasc, "years");
            element.mesi = dataComp.diff(dataNasc, "months") % 12;
        }

        element.sesso = el.sesso.toUpperCase();
        element.stp = el.stp ? el.stp : "";
        element.cittadinanza = nazioniPerCodice[el.cittadinanza]
            ? nazioniPerCodice[el.cittadinanza]
            : "";

        if (el.comuneNascita && allComuniPerCodice[el.comuneNascita]) {
            element.comuneNascita = Utils.getComuneByDescrizione(
                el.comuneNascita,
                el.dataNascita
            );
        } else {
            element.comuneNascita = comuniNazioni[el.comuneNascita];
        }

        if (residenza.regione && residenza.regione.length===2){
            residenza.regione=residenza.regione.concat("0")
        }
        element.regioneResidenza = regioniPerCodice[residenza.regione]
            ? regioniPerCodice[residenza.regione]
            : "";
        element.comuneResidenza = residenza.comune
            ? comuniNazioni[residenza.comune]
            : "";
        element.provinciaResidenza = element.comuneResidenza
            ? provincePerCodice[element.comuneResidenza.codiceProvincia]
            : "";
        element.indirizzoResidenza = residenza.indirizzo;
        element.aslAppartenenza = residenza.ulss;
        element.comuneDomicilio = domicilio.comune
            ? comuniNazioni[domicilio.comune]
            : "";
        element.indirizzoDomicilio = domicilio.indirizzo;
        element.aslDomicilio = domicilio.ulss;
        element.statoEstero = el.statoEstero;
        element.nonInRegola = el.nonInRegola;
        element.senzaFissaDimora = el.senzaFissaDimora;
        element.ssn = el.codiceSsn ? el.codiceSsn : "";
        element.recapitoTelefonicoPaziente =
            el.contatti && el.contatti.length > 0 && el.contatti[0].valore
                ? el.contatti[0].valore
                : "";
        element.professione = el.professione;
        element.mesi = el.etaMesi;

        return element;
    }

    /* static getComuneByDescrizione(comune, dataNascita) {
        let decodedComune;
        if (localStorage.getItem("comuni")) {
            let comuni = JSON.parse(localStorage.getItem("comuni"));
            if (dataNascita) {
                decodedComune = comuni.filter((el) => {
                    return (
                        el.codice.toLowerCase() === comune.toLowerCase() &&
                        (this.isObjectEmpty(el.dataInizioValidita) ||
                            el.dataInizioValidita <= dataNascita) &&
                        (this.isObjectEmpty(el.dataFineValidita) ||
                            el.dataFineValidita >= dataNascita)
                    );
                })[0];
            } else {
                let comuniFiltrati = comuni.filter((el) => {
                    return el.codice.toLowerCase() === comune.toLowerCase();
                });
                decodedComune = comuniFiltrati[comuniFiltrati.length - 1];
            }
            return decodedComune ? decodedComune : "";
        } else return comune;
    } */

    static getComuneByDescrizione(comune, dataNascita) {
        // se non si possono avere i comuni ritorna stringa vuota
        if (!localStorage.getItem("comuni")) return "";
        // definisci la lista di comuni con il codice corrispondente
        let listaComuni = JSON.parse(localStorage.getItem("comuni")).filter(
            (el) => el.codice.toLowerCase() === comune.toLowerCase()
        );
        // se non c'è la data di nascita, ritorna il comune che ha annoFineValidità nullo
        if (!dataNascita)
            return listaComuni.filter((el) => !el.dataFineValidita)[0];
        // se c'è dataNascita ed esiste annoFineValidità ed è superiore a data nascita ritorna lui
        const comuniObsoleti = listaComuni.filter(
            (el) =>
                el.dataFineValidita &&
                new Date(el.dataFineValidita).getTime() >
                    new Date(dataNascita).getTime()
        );
        if (comuniObsoleti.length > 0) return comuniObsoleti[0];
        // altrimenti torna il nuovo comune
        return listaComuni.filter((el) => !el.dataFineValidita)[0];
    }

    static isObjectEmpty(_object) {
        if (_object === undefined || _object === null || _object === "")
            return true;
        if (!_object) return false;
        return (
            Object.entries(_object).length === 0 &&
            _object.constructor === Object
        );
    }

    static areObjectsEquivalent(a, b) {
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);

        // se il num di attributi è differente, sono diversi
        if (aProps.length != bProps.length) {
            return false;
        }

        for (var i = 0; i < aProps.length; i++) {
            var propName = aProps[i];

            //se i valori di una propietà di nome uguale sono diversi, gli oggetti sono diversi
            if (a[propName] !== b[propName]) {
                return false;
            }
        }

        return true;
    }

    static emptyStringToNull(obj) {
        let replaceValue = null;
        let newJson = obj;
        newJson = JSON.parse(JSON.stringify(obj).replace(/""/g, replaceValue));
        newJson = JSON.parse(
            JSON.stringify(newJson).replace(/"00"/g, replaceValue)
        );
        return newJson;
    }

    static transformDateForBackend(date) {
        if (moment(date, "DD/MM/YYYY", true).isValid() && date.replace)
            return date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1");
        else return date;
    }

    static transformTimeStampForFrontend(date) {
        if (!date) return "";

        const d = new Date(date);
        if (isNaN(d.getTime())) return "";

        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();

        return `${day}/${month}/${year}`;
    }


    static transformDateForFrontend(date) {
        if (moment(date, "YYYY-MM-DD", true).isValid() && date.replace)
            return date.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1");
        else if (moment(date, "MM-DD-YYYY", true).isValid() && date.replace) {
            return date.replace(/(\d{2})-(\d{2})-(\d{4})/, "$1/$2/$3");
        } else return date;
    }

    static regexIndexOf(stringa, regex, startpos) {
        var indexOf = stringa.substring(startpos || 0).search(regex);
        return indexOf >= 0 ? indexOf + (startpos || 0) : indexOf;
    }

    static isDateIso(date) {
        //console.log("[DEBUG] Checking for ISO Date")
        return date
            ? date.match(
                  /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/
              )
            : false;
    }

    static sortObjectOfObject(data, attr) {
        var arr = [];
        for (var prop in data) {
            if (data.hasOwnProperty(prop)) {
                var obj = {};
                obj[prop] = data[prop];
                obj.tempSortName = data[prop][attr].toLowerCase();
                arr.push(obj);
            }
        }

        arr.sort(function (a, b) {
            var at = a.tempSortName,
                bt = b.tempSortName;
            return at > bt ? 1 : at < bt ? -1 : 0;
        });

        var result = [];
        for (var i = 0, l = arr.length; i < l; i++) {
            var obj = arr[i];
            delete obj.tempSortName;
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    var id = prop;
                }
            }
            var item = obj[id];
            result.push(item);
        }
        return result;
    }

    static controlloPerDataSegnalazioneAPerMessageError(
        dataSegnalazioneA,
        dataSegnalazioneDa
    ) {
        let messaggioErrore = "";
        if (dataSegnalazioneA !== "") {
            if (
                Utils.isDateInValid(
                    Utils.transformDateForBackend(dataSegnalazioneA),
                    "-"
                )
            ) {
                messaggioErrore =
                    "Data non valida. Inserire 'data segnalazione A' valida";
            } else if (
                Utils.isDateValid(
                    Utils.transformDateForBackend(dataSegnalazioneA),
                    "-"
                )
            ) {
                let date1 = new Date(
                    Utils.transformDateForBackend(dataSegnalazioneA)
                );
                let date2 = new Date(
                    Utils.transformDateForBackend(dataSegnalazioneDa)
                );
                if (date1.getTime() < date2.getTime()) {
                    messaggioErrore =
                        "'Data segnalazione a' non può essere minore di 'Data segnalazione da'";
                }
            }
        }
        return messaggioErrore;
    }

    static controlloPerDataSegnalazioneAPerError(
        dataSegnalazioneA,
        dataSegnalazioneDa
    ) {
        let errore = false;

        if (dataSegnalazioneA !== "") {
            if (
                Utils.isDateInValid(
                    Utils.transformDateForBackend(dataSegnalazioneA),
                    "-"
                )
            ) {
                errore = true;
            } else if (
                Utils.isDateValid(
                    Utils.transformDateForBackend(dataSegnalazioneA),
                    "-"
                )
            ) {
                let date1 = new Date(
                    Utils.transformDateForBackend(dataSegnalazioneA)
                );
                let date2 = new Date(
                    Utils.transformDateForBackend(dataSegnalazioneDa)
                );
                if (date1.getTime() < date2.getTime()) {
                    errore = true;
                }
            }
        }
        return errore;
    }

    static checkDateInterval(dataSegnalazioneA, dataSegnalazioneDa) {
        let errore = false;

        if (
            dataSegnalazioneA !== "" &&
            dataSegnalazioneDa !== "" &&
            dataSegnalazioneA != null &&
            dataSegnalazioneDa != null &&
            Utils.isDateValid(
                Utils.transformDateForBackend(dataSegnalazioneA),
                "-"
            ) &&
            Utils.isDateValid(
                Utils.transformDateForBackend(dataSegnalazioneDa),
                "-"
            )
        ) {
            let date1 = new Date(
                Utils.transformDateForBackend(dataSegnalazioneA)
            );
            let date2 = new Date(
                Utils.transformDateForBackend(dataSegnalazioneDa)
            );

            if (date1.getTime() <= date2.getTime()) {
                errore = true;
            }
        }
        return errore;
    }

    static checkDateIntervalMinore(dataUno, dataDue) {
        let errore = false;

        if (
            dataUno !== "" &&
            dataDue !== "" &&
            dataUno != null &&
            dataDue != null &&
            Utils.isDateValid(Utils.transformDateForBackend(dataUno), "-") &&
            Utils.isDateValid(Utils.transformDateForBackend(dataDue), "-")
        ) {
            let date1 = new Date(Utils.transformDateForBackend(dataUno));
            let date2 = new Date(Utils.transformDateForBackend(dataDue));

            if (date1.getTime() < date2.getTime()) {
                errore = true;
            }
        }
        return errore;
    }

    static checkDateLowerToday(dataString) {
        let errore = false;

        if (dataString !== "" && dataString != null) {
            let date1 = new Date(Utils.transformDateForBackend(dataString));
            let date2 = new Date();
            if (date1.getTime() > date2.getTime()) {
                errore = true;
            }
        }
        return errore;
    }

    static isDateInValid(string, delimiter = "/") {
        let bool = !moment(
            string,
            `YYYY${delimiter}MM${delimiter}DD`,
            true
        ).isValid();
        return bool;
    }

    static isDateValid(string, delimiter = "/") {
        let bool = moment(
            string,
            `YYYY${delimiter}MM${delimiter}DD`,
            true
        ).isValid();
        return bool;
    }

    static isCFValid(CF) {
        if (
            CF.match(
                /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
            ) &&
            this.checkCFLastDigit(CF)
        ) {
            return true;
        } else return false;
    }

    // static isIbanValid(iban) {
    //   if (
    //     iban.match(
    //       /IT\d{2}[ ][a-zA-Z]\d{3}[ ]\d{4}[ ]\d{4}[ ]\d{4}[ ]\d{4}[ ]\d{3}|IT\d{2}[a-zA-Z]\d{22}/
    //     )
    //   )
    //     return true;
    //   else return false;
    // }

    static checkCFLastDigit(cf) {
        var validi, i, s, set1, set2, setpari, setdisp;
        if (cf === "") return "";
        cf = cf.toUpperCase();
        if (cf.length !== 16) return false;
        validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        for (i = 0; i < 16; i++) {
            if (validi.indexOf(cf.charAt(i)) === -1) return false;
        }
        set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
        setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
        s = 0;
        for (i = 1; i <= 13; i += 2)
            s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
        for (i = 0; i <= 14; i += 2)
            s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
        if (s % 26 !== cf.charCodeAt(15) - "A".charCodeAt(0)) return false;
        return true;
    }

    static formatDateISO(dateISO, delimiter = "/") {
        //console.log("[DEBUG] Formatting ISO Date")
        try {
            var date = new Date(dateISO);
            var year = date.getFullYear();

            var month = (1 + date.getMonth()).toString();
            month = month.length > 1 ? month : "0" + month;

            var day = date.getDate().toString();
            day = day.length > 1 ? day : "0" + day;

            if (isNaN(year) || isNaN(month) || isNaN(day))
                throw "DateFormatException";

            return day + delimiter + month + delimiter + year;
        } catch (err) {
            return dateISO;
        }
    }

    // // NB: la data di input è nel formato GG/MM/AAA
    static formatDateUTC(dateString) {
        try {
            let array = dateString.split("/");
            return new Date(
                Date.UTC(array[2], array[1], array[0], 0, 0, 0)
            ).toISOString();
        } catch (err) {
            console.log("Err: la data non è nel formato GG/MM/AAA");
            return dateString;
        }
    }

    //Converte un array in una mappa ponendo come chiave il key se passato
    static arrayToMap(array, key) {
        if (array) {
            let map = {};

            for (let i = 0; i < array.length; i++) {
                if (key) map[array[i][key]] = array[i];
                else map[i] = array[i];
            }
            return map;
        } else {
            return null;
        }
    }

    static groupBy(data, key) {
        return data.reduce((acc, x) => {
            acc[x[key]] = [...(acc[x[key]] || []), x];
            return acc;
        }, {});
    }

    //     static findObjectByKey(array, key, value) {
    // const item = array.find(item=>item.codiceTipo==value);
    //         console.log("FINDDDDDDDDDDDDDD"+ a)
    //            return array.find(x => x.key === value);
    //     }

    static tipi(array, params) {
        const tipi = [];
        for (let i = 0; i < array.length; i++) {
            tipi[i] = {}; // empty object to hold properties added below

            for (const prop in array[i]) {
                tipi[i][prop] = array[i][prop]; // copy properties from arObj to ar2
            }
        } // modify property value in copy
        for (let i = 0; i < tipi.length; i++) {
            for (let z = 0; z < params.length; z++) {
                delete tipi[i][params[z]];
            }
        }

        let result = tipi.reduce((unique, o) => {
            if (!unique.some((obj) => obj.codiceTipo === o.codiceTipo)) {
                unique.push(o);
            }
            return unique;
        }, []);
        return result;
    }

    static addFieldToArrayObjects(array, field1, field2, newField) {
        array.forEach((element) => {
            element[newField] = element[field1] + " - " + element[field2];
        });

        return array;
    }

    //individua l'indice dell'oggetto nell'array, basando la ricerca sul valore di un determinato campo
    static checkObjectInArrayByObjectId(a, idFieldName, idValue) {
        let index = a.findIndex((x) => x[idFieldName] === idValue);
        return index;
    }

    static arrayMove(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    }

    // Converte una mappa in un array
    static mapToArray(map) {
        let array = [];

        for (let key in map) {
            if (!key.includes("$")) array.push(map[key]);
        }
        return array;
    }

    static objectToFieldArray(array, fieldName) {
        let returnedArray = [];
        for (let i in array) {
            returnedArray.push(array[i][fieldName]);
        }
        return returnedArray;
    }

    static sortByKey(array, key) {
        return array.sort(function (a, b) {
            var x = a[key];
            var y = b[key];
            return x < y ? -1 : x > y ? 1 : 0;
        });
    }

    // Converte una mappa in un array di oggetti nella forma:
    // value: oggetto, key: key
    static mapToArraySpecial(map) {
        let array = [];

        for (let key in map) {
            var tempItem = {
                value: "",
                key: "",
            };

            if (!key.includes("$")) {
                tempItem.value = map[key];
                tempItem.key = key;
                array.push(tempItem);
            }
        }
        return array;
    }

    static arrayRemove(arr, value, fieldName) {
        return arr.filter(function (ele) {
            if (fieldName) return ele[fieldName] != value;
            else return ele != value;
        });
    }

    static replaceContentString(string, valueToReplace, newValue) {
        let newString = string.replace(valueToReplace, newValue);
        return newString;
    }

    static eliminaNullArray(array) {
        let arrayNuovo = [];

        for (let key in array) {
            if (!this.isEmpty(array[key])) {
                arrayNuovo.push(array[key]);
            }
        }

        return arrayNuovo;
    }

    static removeEmptyValueFromObject(obj) {
        Object.keys(obj).forEach(function (key) {
            if (Array.isArray(obj[key])) {
                if (Object.values(obj[key]).length === 0) {
                    delete obj[key];
                }
            }
            if (
                obj[key] === "" ||
                obj[key] === null ||
                obj[key] === undefined
            ) {
                delete obj[key];
            } else if (Array.isArray(obj[key])) {
                if (Object.values(obj[key]).length !== 0) {
                    let array = Object.values(obj[key]);
                    for (let i = 0; i < array.length; i++) {
                        if (array[i] && typeof array[i] === "object") {
                            if (Utils.isEmpty(array[i])) {
                                array.splice(i, 1);
                                obj[key] = array;
                                Utils.removeEmptyValueFromObject(obj);
                            }
                        } else if (
                            array[i] === "" ||
                            array[i] === null ||
                            array[i] === undefined
                        ) {
                            array.splice(i, 1);
                            obj[key] = array;
                            Utils.removeEmptyValueFromObject(obj);
                        }
                    }
                } else if (Object.values(obj[key]).length === 0) {
                    delete obj[key];
                    Utils.removeEmptyValueFromObject(obj);
                }
            } else if (obj[key] && typeof obj[key] === "object") {
                if (Utils.isEmpty(obj[key])) {
                    delete obj[key];
                    Utils.removeEmptyValueFromObject(obj);
                } else {
                    Utils.removeEmptyValueFromObject(obj[key]);
                }
            }
        });
        console.log(obj);
        return obj;
    }

    static isEmpty(obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) return false;
        }
        return true;
    }

    static getTodayDate() {
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, "0");
        let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = today.getFullYear();
        return (today = dd + "/" + mm + "/" + yyyy);
    }

    static getTodayDateTimestamp() {
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, "0");
        let MM = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = today.getUTCFullYear();
        let hh = String(today.getUTCHours()).padStart(2, "0");
        let mm = String(today.getUTCMinutes()).padStart(2, "0");
        let ss = String(today.getUTCSeconds()).padStart(2, "0");
        let mmm = today.getUTCMilliseconds();
        let z = "+0000";
        return (today =
            yyyy +
            "-" +
            MM +
            "-" +
            dd +
            "T" +
            hh +
            ":" +
            mm +
            ":" +
            ss +
            "." +
            mmm +
            z);
    }

    static validateDate(data, text1, text2) {
        let validatedata = Utils.checkDateInterval(data, "31/12/1899");
        let validatedataOdierna = Utils.checkDateInterval(
            data,
            Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp())
        );

        if (validatedata) {
            return text1;
        } else if (!validatedataOdierna) {
            return text2;
        }

        return "";
    }

    static getIdSegnalazioneUlss(ulssSegnalazione, idSegnalazione) {
        return ulssSegnalazione + ("" + idSegnalazione).padStart(9, "0");
    }

    static getCompletezzaStep(segnalazione) {
        let datiCompleti = [];
        if (
            segnalazione !== null &&
            segnalazione !== undefined &&
            !Utils.isObjectEmpty(segnalazione)
        ) {
            datiCompleti.push({
                nomeStep: states.DATI_SEGNALAZIONE_E_ANAGRAFICI,
                completo: true,
            });
            if (!Utils.isEmpty(segnalazione.stepConfermati)) {
                if (segnalazione.stepConfermati.datiSanitariConfermati) {
                    datiCompleti.push({
                        nomeStep: states.DATI_SANITARI,
                        completo: true,
                    });
                } else {
                    datiCompleti.push({
                        nomeStep: states.DATI_SANITARI,
                        completo: false,
                    });
                }
                if (segnalazione.stepConfermati.infoConfermate) {
                    datiCompleti.push({
                        nomeStep: states.INFO_CLINICHE,
                        completo: true,
                    });
                } else {
                    datiCompleti.push({
                        nomeStep: states.INFO_CLINICHE,
                        completo: false,
                    });
                }
                if (segnalazione.stepConfermati.esitoConfermato) {
                    datiCompleti.push({
                        nomeStep: states.ESITO,
                        completo: true,
                    });
                } else {
                    datiCompleti.push({
                        nomeStep: states.ESITO,
                        completo: false,
                    });
                }
                if (segnalazione.stepConfermati.datiSpecificiConfermati) {
                    datiCompleti.push({
                        nomeStep: states.DATI_SPECIFICI,
                        completo: true,
                    });
                } else {
                    datiCompleti.push({
                        nomeStep: states.DATI_SPECIFICI,
                        completo: false,
                    });
                }
                if (segnalazione.stepConfermati.schedaSpecialeConfermata) {
                    datiCompleti.push({
                        nomeStep: states.SCHEDA_SPECIALE,
                        completo: true,
                    });
                } else {
                    datiCompleti.push({
                        nomeStep: states.SCHEDA_SPECIALE,
                        completo: false,
                    });
                }
                if (segnalazione.stepConfermati.esitoTbcPolmonareConfermato) {
                    datiCompleti.push({
                        nomeStep: states.SCHEDA_SPECIALE_ESITO_TBC,
                        completo: true,
                    });
                } else {
                    datiCompleti.push({
                        nomeStep: states.SCHEDA_SPECIALE_ESITO_TBC,
                        completo: false,
                    });
                }
            } else {
                datiCompleti.push({
                    nomeStep: states.DATI_SEGNALAZIONE_E_ANAGRAFICI,
                    completo: true,
                });
                datiCompleti.push({
                    nomeStep: states.DATI_SANITARI,
                    completo: false,
                });
                datiCompleti.push({
                    nomeStep: states.INFO_CLINICHE,
                    completo: false,
                });
                datiCompleti.push({ nomeStep: states.ESITO, completo: false });
                datiCompleti.push({
                    nomeStep: states.DATI_SPECIFICI,
                    completo: false,
                });
                datiCompleti.push({
                    nomeStep: states.SCHEDA_SPECIALE,
                    completo: false,
                });
                datiCompleti.push({
                    nomeStep: states.SCHEDA_SPECIALE_ESITO_TBC,
                    completo: false,
                });
            }
        }
        return datiCompleti;
    }

    static removeFieldFromObject(object, fieldName) {
        delete object[fieldName];
        return object;
    }

    static getMonthsBetween(date1, date2, roundUpFractionalMonths) {
        //Months will be calculated between start and end dates.
        //Make sure start date is less than end date.
        //But remember if the difference should be negative.
        var startDate = date1;
        var endDate = date2;
        var inverse = false;
        if (date1 > date2) {
            startDate = date2;
            endDate = date1;
            inverse = true;
        }

        //Calculate the differences between the start and end dates
        var yearsDifference = endDate.getFullYear() - startDate.getFullYear();
        var monthsDifference = endDate.getMonth() - startDate.getMonth();
        var daysDifference = endDate.getDate() - startDate.getDate();

        var monthCorrection = 0;
        //If roundUpFractionalMonths is true, check if an extra month needs to be added from rounding up.
        //The difference is done by ceiling (round up), e.g. 3 months and 1 day will be 4 months.
        if (roundUpFractionalMonths === true && daysDifference > 0) {
            monthCorrection = 1;
        }
        //If the day difference between the 2 months is negative, the last month is not a whole month.
        else if (roundUpFractionalMonths !== true && daysDifference < 0) {
            monthCorrection = -1;
        }

        var mesi =
            (inverse ? -1 : 1) *
            (yearsDifference * 12 + monthsDifference + monthCorrection);

        return mesi;
    }

    //passo l'elemento e restituiche la label
    static getTypeEsito(esito) {
        switch (esito.severita) {
            case "S001":
                return "successo";
            case "S010":
                return "confirm";
            case "S100":
                return "critical";
            default:
                return "confirm";
        }
    }

    static checkIdSegnalazione(idSegnalazione) {
        let regex = "(?<!\\d)\\d{15}(?!\\d)";

        let valore = false;
        if (idSegnalazione.match(regex)) {
            valore = true;
        }

        return valore;
    }

    static createDiv(
        tipocol1,
        tipocol2,
        tipocol3,
        riceviValore,
        stato,
        t,
        rows,
        tipocol4,
        tipocol5,
        tipocol6,
        defaultDivStyle
    ) {
        let boxes = [];
        let riga = {};
        let col1 = {};
        let col2 = {};
        let col3 = {};
        let col4 = {};
        let col5 = {};
        let col6 = {};
        if (rows) {
            for (let i = 0; i < rows.length; i++) {
                for (let key in rows[i]) {
                    let campo =
                        rows[i][key].tipo === "input" ? (
                            <Input
                                id={rows[i][key].id}
                                field={rows[i][key].field}
                                onChange={riceviValore}
                                required={rows[i][key].required}
                                value={stato[rows[i][key].field]}
                                placeholder={t(rows[i][key].text)}
                                disabled={rows[i][key].disabled}
                            />
                        ) : rows[i][key].tipo === "radio" ? (
                            <RadioButton
                                id={rows[i][key].id}
                                name={rows[i][key].name}
                                label={t(rows[i][key].text)}
                                value={rows[i][key].value}
                                required={rows[i][key].required}
                                newRadio={true}
                                disabled={rows[i][key].disabled}
                                style={{
                                    color: "black",
                                    fontSize: rows[i][key].smallLabel
                                        ? "14px"
                                        : "",
                                }}
                                onClick={riceviValore}
                                checked={
                                    stato[rows[i][key].name] ===
                                    rows[i][key].value
                                }
                            />
                        ) : rows[i][key].tipo === "data" ? (
                            <Calendar
                                id={rows[i][key].id}
                                value={stato[rows[i][key].field]}
                                field={rows[i][key].field}
                                onChange={riceviValore}
                                disabled={rows[i][key].disabled}
                                newCalendar={true}
                                errorMessage={Utils.replaceContentString(
                                    t("Messages.ERR_01_01_0B_0A"),
                                    "<nome campo>",
                                    t(rows[i][key].text)
                                )}
                                error={
                                    !stato[rows[i][key].field]
                                        ? false
                                        : Utils.isDateInValid(
                                              Utils.transformDateForBackend(
                                                  stato[rows[i][key].field]
                                              ),
                                              "-"
                                          )
                                }
                            />
                        ) : rows[i][key].tipo === "label" ? (
                            <p
                                className={styles.testo}
                                style={{
                                    color: "black",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                }}
                            >
                                {t(rows[i][key].text)}
                                {rows[i][key].asterisco ? (
                                    <span className={styles.mandatoryColor}>
                                        *
                                    </span>
                                ) : (
                                    <div></div>
                                )}
                                <span
                                    style={{
                                        color: "black",
                                        fontWeight: "normal",
                                    }}
                                >
                                    {t(rows[i][key].textAggiuntivo)}
                                </span>
                            </p>
                        ) : rows[i][key].tipo === "select" ? (
                            <Select
                                value={stato[rows[i][key].field]}
                                field={rows[i][key].field}
                                id={rows[i][key].id}
                                newSelect={true}
                                defaultSelect={rows[i][key].defaultSelect}
                                onChange={riceviValore}
                                functionMap={Utils.mapToArray(
                                    rows[i][key].suggestions
                                ).map((oggetto) => {
                                    return (
                                        <option value={oggetto.codice}>
                                            {oggetto.descrizione}
                                        </option>
                                    );
                                })}
                            />
                        ) : rows[i][key].tipo === "autocomplete" ? (
                            <Autocomplete
                                id={rows[i][key].id}
                                onChange={riceviValore}
                                field={rows[i][key].field}
                                keyField={rows[i][key].keyField}
                                disabled={rows[i][key].disabled}
                                descriptionField={rows[i][key].descriptionField}
                                suggestionField={rows[i][key].suggestionField}
                                value={stato[rows[i][key].field]}
                                placeholder={t(rows[i][key].text)}
                                suggestions={rows[i][key].suggestions}
                            />
                        ) : rows[i][key].tipo === "check" ? (
                            <CheckBox
                                id={rows[i][key].id}
                                deselectStyle={false}
                                field={rows[i][key].field}
                                disabled={rows[i][key].disabled}
                                checked={stato[rows[i][key].id]["checked"]}
                                text={t(rows[i][key].text)}
                                onChange={riceviValore}
                                onClick={rows[i][key].onClick}
                                newCheckbox={true}
                                defaultChecked={rows[i][key].defaultChecked}
                                fontColor={rows[i][key].fontColor}
                                fontSize={rows[i][key].fontSize}
                            />
                        ) : (
                            <div></div>
                        );

                    if (rows[i][key].colonna === 1) {
                        col1 = (
                            <div
                                style={rows[i][key].style}
                                className={tipocol1}
                            >
                                {campo}
                            </div>
                        );
                    } else if (rows[i][key].colonna === 2) {
                        col2 = (
                            <div
                                style={rows[i][key].style}
                                className={tipocol2}
                            >
                                {campo}
                            </div>
                        );
                    } else if (rows[i][key].colonna === 3) {
                        col3 = (
                            <div
                                style={rows[i][key].style}
                                className={tipocol3}
                            >
                                {campo}
                            </div>
                        );
                    } else if (rows[i][key].colonna === 4) {
                        col4 = (
                            <div
                                style={rows[i][key].style}
                                className={tipocol4}
                            >
                                {campo}
                            </div>
                        );
                    } else if (rows[i][key].colonna === 5) {
                        col5 = (
                            <div
                                style={rows[i][key].style}
                                className={tipocol5}
                            >
                                {campo}
                            </div>
                        );
                    } else if (rows[i][key].colonna === 6) {
                        col6 = (
                            <div
                                style={rows[i][key].style}
                                className={tipocol6}
                            >
                                {campo}
                            </div>
                        );
                    }
                }

                riga = (
                    <div>
                        <div
                            className={"row"}
                            style={
                                defaultDivStyle
                                    ? defaultDivStyle
                                    : { marginTop: "1rem" }
                            }
                        >
                            {Utils.isEmpty(col1) ? (
                                <div className={tipocol1} />
                            ) : (
                                col1
                            )}
                            {Utils.isEmpty(col2) ? (
                                <div className={tipocol2} />
                            ) : (
                                col2
                            )}
                            {Utils.isEmpty(col3) ? (
                                <div className={tipocol3} />
                            ) : (
                                col3
                            )}
                            {Utils.isEmpty(col4) ? (
                                <div className={tipocol4} />
                            ) : (
                                col4
                            )}
                            {Utils.isEmpty(col5) ? (
                                <div className={tipocol5} />
                            ) : (
                                col5
                            )}
                            {Utils.isEmpty(col6) ? (
                                <div className={tipocol6} />
                            ) : (
                                col6
                            )}
                        </div>
                    </div>
                );
                col1 = col2 = col3 = col4 = col5 = col6 = {};
                boxes.splice(i, 0, riga);
            }
        }
        return boxes;
    }

    static distinctComuni(comuni, dataOdierna) {
        let distinctComuni = [];
        if (dataOdierna) {
            for (let i = 0; i < comuni.length; i++) {
                if (
                    comuni[i].codice !==
                        (comuni[i + 1] && comuni[i + 1].codice) &&
                    (!comuni[i].dataFineValidita ||
                        comuni[i].dataFineValidita > dataOdierna)
                ) {
                    distinctComuni.push(comuni[i]);
                } else if (
                    comuni[i + 1] &&
                    comuni[i].codice === comuni[i + 1].codice &&
                    comuni[i + 1] &&
                    comuni[i].codiceProvincia ===
                        comuni[i + 1].codiceProvincia &&
                    (!comuni[i].dataFineValidita ||
                        (comuni[i].dataFineValidita &&
                            comuni[i].dataFineValidita > dataOdierna))
                ) {
                    distinctComuni.splice(i, 1, comuni[i]);
                }
            }
        } else {
            for (let i in comuni) {
                if (i == 0) {
                    distinctComuni.push(comuni[i]);
                } else {
                    if (comuni[i].descrizione !== comuni[i - 1].descrizione) {
                        distinctComuni.push(comuni[i]);
                    } else if (
                        distinctComuni[distinctComuni.length - 1]
                            .dataFineValidita < comuni[i].dataFineValidita ||
                        !comuni[i].dataFineValidita
                    ) {
                        distinctComuni.splice(
                            distinctComuni.length - 1,
                            1,
                            comuni[i]
                        );
                    }
                }
            }
        }
        return distinctComuni;
    }

    static distinctAulss(aulss, dataOdierna) {
        let distinctAulss = [];
        if (dataOdierna) {
            for (let i = 0; i < aulss.length; i++) {
                if (
                    aulss[i].codice !== (aulss[i + 1] && aulss[i + 1].codice) &&
                    (!aulss[i].dataFineValidita ||
                        aulss[i].dataFineValidita > dataOdierna)
                ) {
                    distinctAulss.push(aulss[i]);
                } else if (
                    aulss[i + 1] &&
                    aulss[i].codice === aulss[i + 1].codice &&
                    aulss[i + 1] &&
                    aulss[i].codiceProvincia === aulss[i + 1].codiceProvincia &&
                    (!aulss[i].dataFineValidita ||
                        (aulss[i].dataFineValidita &&
                            aulss[i].dataFineValidita > dataOdierna))
                ) {
                    distinctAulss.splice(i, 1, aulss[i]);
                }
            }
        } else {
            for (let i in aulss) {
                if (i == 0) {
                    distinctAulss.push(aulss[i]);
                } else {
                    if (aulss[i].descrizione !== aulss[i - 1].descrizione) {
                        distinctAulss.push(aulss[i]);
                    } else if (
                        distinctAulss[distinctAulss.length - 1]
                            .dataFineValidita < aulss[i].dataFineValidita ||
                        !aulss[i].dataFineValidita
                    ) {
                        distinctAulss.splice(
                            distinctAulss.length - 1,
                            1,
                            aulss[i]
                        );
                    }
                }
            }
        }
        return distinctAulss;
    }

    static filtroProvinceComuni(codice, lista, filtro) {
        let nuovaLista = [];
        if (codice) {
            if(filtro ==="codiceRegione" && codice.length===3){
                codice=codice.slice(0,-1)
            }
            for (let i = 0; i < lista.length; i++) {
                if (codice === lista[i][filtro]) {
                    nuovaLista.push(lista[i]);
                }
            }
        }
        return nuovaLista;
    }

    static disabledSelectAutocomplete(condizione) {
        if (condizione) {
            $(document).ready(function () {
                $(".selectpicker").selectpicker("disabled");
                $(".selectpicker").selectpicker("refresh");
            });
        } else {
            $(document).ready(function () {
                $(".selectpicker").selectpicker("disabled", false);
                $(".selectpicker").selectpicker("refresh");
            });
        }
    }

    static disabledDateTabellaConfermaLaboratorio(id, state) {
        if (id === "Morbillo") {
            if (state.confermaDiLaboratorioMorbillo.ricercaIgm !== "true") {
                $(document).ready(function () {
                    $("#dataRaccoltaCampioneRicergaIgmMorbillo").datepicker(
                        "disable"
                    );
                });
            } else {
                $(document).ready(function () {
                    $("#dataRaccoltaCampioneRicergaIgmMorbillo").datepicker(
                        "enable"
                    );
                });
            }
            if (state.confermaDiLaboratorioMorbillo.ricercaIgg !== "true") {
                $(document).ready(function () {
                    $(
                        "#primaDataRaccoltaCampioneRicergaIggMorbillo"
                    ).datepicker("disable");
                    $(
                        "#secondaDataRaccoltaCampioneRicergaIggMorbillo"
                    ).datepicker("disable");
                });
            } else {
                $(document).ready(function () {
                    $(
                        "#primaDataRaccoltaCampioneRicergaIggMorbillo"
                    ).datepicker("enable");
                    $(
                        "#secondaDataRaccoltaCampioneRicergaIggMorbillo"
                    ).datepicker("enable");
                });
            }
            if (state.confermaDiLaboratorioMorbillo.pcr !== "true") {
                $(document).ready(function () {
                    $("#dataRaccoltaCampionePcrMorbillo").datepicker("disable");
                });
            } else {
                $(document).ready(function () {
                    $("#dataRaccoltaCampionePcrMorbillo").datepicker("enable");
                });
            }
            if (state.confermaDiLaboratorioMorbillo.altroTest !== "true") {
                $(document).ready(function () {
                    $("#dataRaccoltaCampioneAltroTestMorbillo").datepicker(
                        "disable"
                    );
                });
            } else {
                $(document).ready(function () {
                    $("#dataRaccoltaCampioneAltroTestMorbillo").datepicker(
                        "enable"
                    );
                });
            }
        } else if (id === "Rosolia") {
            if (state.confermaDiLaboratorioRosolia.ricercaIgm !== "true") {
                $(document).ready(function () {
                    $("#dataRaccoltaCampioneRicergaIgmRosolia").datepicker(
                        "disable"
                    );
                });
            } else {
                $(document).ready(function () {
                    $("#dataRaccoltaCampioneRicergaIgmRosolia").datepicker(
                        "enable"
                    );
                });
            }
            if (state.confermaDiLaboratorioRosolia.ricercaIgg !== "true") {
                $(document).ready(function () {
                    $("#primaDataRaccoltaCampioneRicergaIggRosolia").datepicker(
                        "disable"
                    );
                    $(
                        "#secondaDataRaccoltaCampioneRicergaIggRosolia"
                    ).datepicker("disable");
                });
            } else {
                $(document).ready(function () {
                    $("#primaDataRaccoltaCampioneRicergaIggRosolia").datepicker(
                        "enable"
                    );
                    $(
                        "#secondaDataRaccoltaCampioneRicergaIggRosolia"
                    ).datepicker("enable");
                });
            }
            if (state.confermaDiLaboratorioRosolia.pcr !== "true") {
                $(document).ready(function () {
                    $("#dataRaccoltaCampionePcrRosolia").datepicker("disable");
                });
            } else {
                $(document).ready(function () {
                    $("#dataRaccoltaCampionePcrRosolia").datepicker("enable");
                });
            }
            if (state.confermaDiLaboratorioRosolia.altroTest !== "true") {
                $(document).ready(function () {
                    $("#dataRaccoltaCampioneAltroTestRosolia").datepicker(
                        "disable"
                    );
                });
            } else {
                $(document).ready(function () {
                    $("#dataRaccoltaCampioneAltroTestRosolia").datepicker(
                        "enable"
                    );
                });
            }
        }
    }

    static checkFunzionalitaByRuolo(idFunzionalita) {
        //se sono ancora loggato
        //e se è specificata la mappa delle funzionalità NON accessibili per il mio ruolo
        //e se la funzionalità NON è accessibile per il mio ruolo
        return !(
            SessioneUtente.getInstance() != null &&
            Permessi[SessioneUtente.getInstance().ruoliUtente] &&
            Permessi[SessioneUtente.getInstance().ruoliUtente].includes(
                idFunzionalita
            )
        );
    }

    static downloadReport = (
        byte,
        fileName,
        extension,
        fileFirmato = false
    ) => {
        let mimeType = {
            pdf: "application/pdf",
            xml: "application/xml",
            xls: "application/vnd.ms-excel",
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            doc: "application/msword",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            zip: "application/octet-stream",
            p7m: "application/pkcs7-mime",
            csv: "text/csv",
        };
        if (fileFirmato) var byteCharacters = byte;
        else var byteCharacters = atob(byte);

        var byteArrays = [];
        var sliceSize = 512;
        for (
            var offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: mimeType[extension] });
        if (window.navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, fileName + "." + extension);
            return;
        }
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName + "." + extension;
        document.body.appendChild(a);
        a.click();
    };

    static diffDays(firstDate, secondDate) {
        let diffTime = Math.abs(secondDate - firstDate);
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }

    static daysBetween(StartDate, EndDate) {
        // The number of milliseconds in all UTC days (no DST)
        const oneDay = 1000 * 60 * 60 * 24;

        // A day in UTC always lasts 24 hours (unlike in other time formats)
        const start = Date.UTC(
            EndDate.getFullYear(),
            EndDate.getMonth(),
            EndDate.getDate()
        );
        const end = Date.UTC(
            StartDate.getFullYear(),
            StartDate.getMonth(),
            StartDate.getDate()
        );

        // so it's safe to divide by 24 hours
        return (start - end) / oneDay;
    }

    static monthDiff(d1, d2) {
        let months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        return months <= 0 ? 0 : months;
    }

    static object_equals(x, y) {
        if (x === y) return true;
        if (!(x instanceof Object) || !(y instanceof Object)) return false;
        if (x.constructor !== y.constructor) return false;
        for (var p in x) {
            if (!x.hasOwnProperty(p)) continue;
            if (!y.hasOwnProperty(p)) return false;
            if (x[p] === y[p]) continue;
            if (typeof x[p] !== "object") return false;
            if (!Utils.object_equals(x[p], y[p])) return false;
        }
        for (p in y)
            if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
        return true;
    }

    static between(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }

    static getRandomString() {
        const randomItems = new Uint32Array(28);
        window.crypto.getRandomValues(randomItems);
        const binaryStringItems = randomItems.map(
            (dec) => `0${dec.toString(16).substr(-2)}`
        );
        return binaryStringItems.reduce((acc, item) => `${acc}${item}`, "");
    }

    static encryptStringWithSHA256 = async (str) => {
        const PROTOCOL = "SHA-256";
        const textEncoder = new TextEncoder();
        const encodedData = textEncoder.encode(str);
        return window.crypto.subtle.digest(PROTOCOL, encodedData);
    };

    static hashToBase64url(arrayBuffer) {
        const items = new Uint8Array(arrayBuffer);
        const stringifiedArrayHash = items.reduce(
            (acc, i) => `${acc}${String.fromCharCode(i)}`,
            ""
        );
        const decodedHash = btoa(stringifiedArrayHash);
        const base64URL = decodedHash
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
        return base64URL;
    }

    static parseJwt(token) {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map(function (c) {
                    return (
                        "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
                    );
                })
                .join("")
        );

        return JSON.parse(jsonPayload);
    }

    static checkStringInArray(array) {
        let ok = false;
        let newArray = array.split(",");
        for (let key in newArray) {
            if (OggettiUtili.GruppiSirmi.includes(newArray[key])) {
                ok = true;
            } else {
                ok = false;
                return ok;
            }
        }
        return ok;
    }

    static toBase64(file) {
        return new Promise(function (resolve, reject) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = (error) => reject(error);
        });
    }

    static filtraStruttureAndStabilimenti(ulss, struttureAndStabilimenti) {
        let struttureAndStabilimentiFiltrati = [];
        let struttureAndStabilimentiRestanti = [];

        struttureAndStabilimenti.forEach((element) => {
            if (element.codice.startsWith(ulss)) {
                struttureAndStabilimentiFiltrati.push(element);
            } else {
                struttureAndStabilimentiRestanti.push(element);
            }
        });

        let res = {
            struttureAndStabilimentiFiltrati: struttureAndStabilimentiFiltrati,
            struttureAndStabilimentiRestanti: struttureAndStabilimentiRestanti,
        };

        return res;
    }

    static async getFiles(filesCaricatiInput, filesDaCaricareInput) {
        let filesCaricati = filesCaricatiInput;
        let filesDaCaricare = filesDaCaricareInput;
        let files = [];

        for (const element of filesDaCaricare) {
            if (element.checked) {
                let base64 = await Utils.toBase64(element);
                if (base64) {
                    let file = {
                        nome: element.name ?? element.nome,
                        file: base64,
                        note: element.note ?? "",
                        data: element.data,
                        stato: element.stato,
                    };

                    files.push(file);
                }
            }
        }

        filesCaricati.forEach((element) => {
            if (element.stato === "modifica" && element.checked) {
                let file = {
                    idFile: element.id,
                    note: element.note ?? "",
                    stato: element.stato,
                    nome: element.name ?? element.nome,
                };
                files.push(file);
            } else if (!element.checked) {
                let file = {
                    idFile: element.id,
                    stato: "eliminazione",
                };
                files.push(file);
            }
        });

        return files;
    }

    static visualizzaPdf(e, id, segnalazioneCopia, showSpinner) {
        let idPdf = id ? id : segnalazioneCopia.idPdf;
        showSpinner(true);
        SegnalazioniService.getPdf(idPdf)
            .then((data) => {
                let documento = data.data.file;
                let arrayBuffer = Uint8Array.from(atob(documento), (c) =>
                    c.charCodeAt(0)
                );
                let file = new Blob([arrayBuffer], {
                    type: "application/pdf;base64",
                });
                let fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                showSpinner(false);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    static controlloModificaCampi(segnalazione) {
        if (
            OggettiUtili.malattieConSchedaSpeciale.includes(
                segnalazione.malattia
            )
        ) {
            if (
                segnalazione.statoValidazione ===
                    OggettiUtili.statoValidazioneByLabel.Validata.codice ||
                (segnalazione.stepConfermati &&
                    segnalazione.stepConfermati.datiSpecificiConfermati)
            ) {
                return true;
            }
        } else {
            if (
                segnalazione.statoValidazione ===
                OggettiUtili.statoValidazioneByLabel.Validata.codice
            ) {
                return true;
            }
        }
    }

    static isRecapitoTelefonicoValid(telefono) {
        return telefono.match(
            "^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{2,6}$"
        );
    }

    static retrieveIdoneitaPremal(segnalazione, datiPaziente, datiMedico) {
        let idoneoPremal = {};
        idoneoPremal["idoneita"] = false;
        let idoneitaPremal = segnalazione.idoneitaPremal
            ? segnalazione.idoneitaPremal
            : idoneoPremal;
        if (
            this.isSegnalazioneCompliantPremal(segnalazione) &&
            this.isPazienteCompliantPremal(datiPaziente) &&
            this.isMedicoCompliantPremal(datiMedico)
        ) {
            if (!idoneitaPremal["idoneita"]) {
                idoneitaPremal["idoneita"] = true;
                idoneitaPremal["dataIdoneitaPremal"] =
                    this.getTodayDateTimestamp();
            }
        } else {
            if (idoneitaPremal["idoneita"]) {
                let newIdoneitaPremal = {};
                newIdoneitaPremal["idoneita"] = false;
                return newIdoneitaPremal;
            }
        }
        return idoneitaPremal;
    }

    static isSegnalazioneCompliantPremal(segnalazione) {
        return (
            segnalazione &&
            segnalazione.ulssSegnalazione &&
            segnalazione.comune &&
            segnalazione.dataSegnalazione &&
            segnalazione.malattia &&
            segnalazione.sesso &&
            segnalazione.datiSanitari &&
            segnalazione.datiSanitari.dataInizioSintomi &&
            segnalazione.datiSanitari.ricovero &&
            (segnalazione.datiSanitari.ricovero === "0" ||
                (segnalazione.datiSanitari.ricovero === "1" &&
                    (segnalazione.datiSanitari.struttura ||
                        segnalazione.datiSanitari.strutturaExtra))) &&
            segnalazione.infoCliniche &&
            segnalazione.infoEpidemiologiche &&
            segnalazione.infoLaboratorio
        );
    }

    static isPazienteCompliantPremal(datiPaziente) {
        return (
            datiPaziente &&
            datiPaziente.nomePaziente &&
            datiPaziente.cognomePaziente &&
            datiPaziente.dataDiNascita &&
            datiPaziente.comuneNascita &&
            (datiPaziente.cfNonNoto === true ||
                datiPaziente.codiceFiscale ||
                datiPaziente.stp ||
                datiPaziente.ssn) &&
            (datiPaziente.senzaFissaDimora ||
                (datiPaziente.comuneResidenza &&
                    datiPaziente.aslAppartenenza)) &&
            datiPaziente.cittadinanza &&
            datiPaziente.professione
        );
    }

    static isMedicoCompliantPremal(datiMedico) {
        return (
            datiMedico &&
            datiMedico.nome &&
            datiMedico.cognome &&
            datiMedico.ruolo
        );
    }

    static scrollToTheTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }

    static camelCaseToTitleCase(inputString) {
        const words = inputString.split(/(?=[A-Z])/);

        const titleCaseWords = words.map((word) => {
            if (word.length > 0) {
                return word[0].toUpperCase() + word.slice(1).toLowerCase();
            } else {
                return "";
            }
        });

        return titleCaseWords.join(" ");
    }

    static getArrayUlss() {
        let arrayUlss = [];
        let aziendeOspedaliere = ["050902", "050901", "050952", "050017", "050022"];
        Object.keys(OggettiUtili.ulssMap).map((key) => {
            arrayUlss.push(OggettiUtili.ulssMap[key]);
        });
        if (
            SessioneUtente.getInstance().ruoliUtente ===
            Ruoli.Operatore_Regionale.descrizione
        ) {
            arrayUlss = arrayUlss.filter(function (obj) {
                return !aziendeOspedaliere.includes(obj.codice);
            });
        }
        return arrayUlss;
    }

    static isDateFieldWrong = (type, firstChar, secondChar) =>
        (firstChar === "0" && secondChar === "0") ||
        (type === "giorno" && firstChar === "3" && +secondChar > 1) ||
        (type === "mese" && firstChar === "1" && +secondChar > 2);

    static isValidDate = (annoIndicato, mese, giorno) => {
        const params = [giorno, mese, annoIndicato];
        for (let param of params) if (param.includes("#")) return true;
        // calcola anno corretto
        const annoCorrente = +new Date().getFullYear().toString().substring(2);

        const annoComplessivo = +`${
            +annoIndicato > annoCorrente ? `19` : `20`
        }${annoIndicato}`;
        // il mese è in base 0 quindi va sottratto 1
        mese = +mese - 1;

        const dateObject = new Date(+annoComplessivo, +mese, +giorno);
        return (
            dateObject.getFullYear() === +annoComplessivo &&
            dateObject.getMonth() === +mese &&
            dateObject.getDate() === +giorno
        );
    };

    static getInputWrongDateMessage = (input) => {
        if (input[4] === undefined) return "";
        if (!/^[0123#]$/.test(input[4]))
            return "I caratteri in posizione 5 e 6 devono essere il giorno di nascita";
        if (input[5] === undefined) return "";
        if (
            !/^[0-9#]+$/.test(input[5]) ||
            this.isDateFieldWrong("giorno", input[4], input[5])
        )
            return `${input[4]}${input[5]} non è un giorno di nascita valido`;
        if (input[6] === undefined) return "";

        if (!/^[01#]$/.test(input[6]))
            return "I caratteri in posizione 7 e 8 devono essere il mese di nascita";
        if (input[7] === undefined) return "";
        if (
            !/^[0-9#]+$/.test(input[7]) ||
            this.isDateFieldWrong("mese", input[6], input[7])
        )
            return `${input[6]}${input[7]} non è un mese di nascita valido`;

        const giornoIndicato = `${input[4]}${input[5]}`.toString();
        const meseIndicato = `${input[6]}${input[7]}`.toString();

        if (!this.isValidDate("20", meseIndicato, giornoIndicato))
            return `La data ${giornoIndicato}/${
                meseIndicato < 10 ? `0` : ""
            }${meseIndicato} non è corretta`;

        let counter = 8;
        do {
            if (input[counter] === undefined) return "";
            if (!/^[0-9#]+$/.test(input[counter]))
                return "I caratteri delle posizioni 9 e 10 devono corrispondere all'anno di nascita";
            counter++;
        } while (counter < 10);

        const annoIndicato = `${input[8]}${input[9]}`.toString();

        if (!this.isValidDate(annoIndicato, meseIndicato, giornoIndicato))
            return `La data ${giornoIndicato}/${
                meseIndicato < 10 ? `0` : ""
            }${meseIndicato}/${
                annoIndicato < 10 ? `0` : ""
            }${annoIndicato} non è corretta`;

        return "";
    };

    static isDateOnCodiceUnivocoValid = (valoreCodiceUnivoco) =>
        valoreCodiceUnivoco.length === 11 &&
        !valoreCodiceUnivoco.substring(4, 10).includes("#");

    static isDateOnlyYearValid = (valoreCodiceUnivoco) =>
        valoreCodiceUnivoco.length === 11 &&
        !valoreCodiceUnivoco.substring(9, 10).includes("#");

    static isSexOnCondiceUnivocoValid = (valoreCodiceUnivoco) =>
        valoreCodiceUnivoco.charAt(10) !== "#";

    static getMessaggioErroreCodiceUnivocoPazienteHIV = (
        valoreCodiceUnivoco
    ) => {
        // Verifica la lunghezza dell'input
        if (valoreCodiceUnivoco.length > 11) {
            return "Codice troppo lungo";
        }

        // Verifica i primi 4 caratteri: devono essere lettere
        for (
            let i = 0;
            i <
            (valoreCodiceUnivoco.length < 4 ? valoreCodiceUnivoco.length : 4);
            i++
        ) {
            if (!/[a-zA-Z#]/.test(valoreCodiceUnivoco[i])) {
                return "I primi 4 caratteri devono essere lettere alfabetiche oppure '#'";
            }
        }

        const errorDate = this.getInputWrongDateMessage(valoreCodiceUnivoco);
        if (errorDate !== "") return errorDate;

        if (valoreCodiceUnivoco.length < 11) return "";

        // Verifica l'ultimo carattere: deve essere 'M' o 'F'
        if (
            valoreCodiceUnivoco[10] !== "m" &&
            valoreCodiceUnivoco[10] !== "f" &&
            valoreCodiceUnivoco[10] !== "M" &&
            valoreCodiceUnivoco[10] !== "F" &&
            valoreCodiceUnivoco[10] !== "#"
        ) {
            return "L'ultimo carattere deve essere 'M' o 'F' o '#'";
        }

        // Se tutti i controlli passano, l'errore è vuoto e l'input è valido
        return "";
    };

    static isDateInTheFuture(dateString) {
        if (dateString === "" || this.isDateInValid(dateString)) return false;
        return new Date(dateString).getTime() > Date.now();
    }

    static progressivoRegistroZero(progressivoRegistro) {
        const lunghezzaProgressivi = progressivoRegistro.toString().length;
        const frt = 9;
        const lZero = frt - lunghezzaProgressivi;
        for (let index = 0; index < lZero; index++) {
            progressivoRegistro = "0".concat(progressivoRegistro.toString());
        }

        return progressivoRegistro;
    }

    static idSegnalazioneUlss(res) {
        for (let row of res) {
            row.progressivoRegistro =
                row.appoStruttura +
                this.progressivoRegistroZero(row.progressivoRegistro);
        }
        return res;
    }

    static getNumeroFromCodiceStruttura = (el) =>
        +el.codiceStruttura.split("N. ")[1][0];

    static getNumeroFromProgressivoRegistro = (el) =>
        +el.progressivoRegistro.substring(6);

    static sortByCodiceStruttura = (a, b) =>
        this.getNumeroFromCodiceStruttura(a) -
        this.getNumeroFromCodiceStruttura(b);

    static sortByProgressivoRegistro = (a, b) =>
        this.getNumeroFromProgressivoRegistro(a) -
        this.getNumeroFromProgressivoRegistro(b);

    static sortByCodiceUnivoco = (a, b) =>
        a.codiceIndividualePaziente < b.codiceIndividualePaziente
            ? -1
            : a.codiceIndividualePaziente > b.codiceIndividualePaziente
            ? 1
            : 0;

    static sortByDataSegnalazione = (a, b) =>
        new Date(a.dataSegnalazione).getTime() -
        new Date(b.dataSegnalazione).getTime();

    static retrieveMatrixFromListPerGestioneDuplicatiHiv = (originalList) => {
        // create una matrice dalla lista
        let matrice = [];
        let sublist = [];
        for (let i = 0; i < originalList.length; i++) {
            // se la sublista è vuota aggiungi il record alla sublist
            if (sublist.length === 0) {
                sublist = [originalList[i]];
                // se la sublist non è vuota e contiene già un elemento con stesso CU append
            } else if (
                sublist.find(
                    (el) =>
                        el.codiceIndividualePaziente ===
                        originalList[i].codiceIndividualePaziente
                )
            ) {
                sublist.push(originalList[i]);
                // altrimenti aggiungi la vecchia sublist alla list, e reinizializza
            } else {
                matrice.push(sublist);
                sublist = [originalList[i]];
            }
        }
        // aggiungila l'ultima sublist
        if (sublist.length > 0) matrice.push(sublist);
        return matrice;
    };
}
